<template>
  <main>
    <div class="content">
      <div class="row">
        <div class="col-md-7">
          <h1>{{ title }}</h1>
        </div>
        <div class="col-md-5" v-if="title == 'Página Inicial'">
          <div class="search">
            <button
              @click="pesquisa(1)"
              class="btn_dias"
              :class="dias == '1' ? 'ativo' : ''"
            >
              Último dia
            </button>
            <button
              @click="pesquisa(7)"
              class="btn_dias"
              :class="dias == '7' ? 'ativo' : ''"
            >
              7 dias
            </button>
            <button
              @click="pesquisa(15)"
              class="btn_dias"
              :class="dias == '15' ? 'ativo' : ''"
            >
              15 dias
            </button>
            <button
              @click="pesquisa(30)"
              class="btn_dias"
              :class="dias == '30' ? 'ativo' : ''"
            >
              30 dias
            </button>
            <button
              @click="pesquisa(60)"
              class="btn_dias"
              :class="dias == '60' ? 'ativo' : ''"
            >
              60 dias
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
const emit = defineEmits(["diasPesquisa"]); // Definição do evento
defineProps({
  title: {
    type: String,
    required: true,
  },
  dias: {
    type: String,
    required: true,
  },
});

function pesquisa(dias) {
  emit("diasPesquisa", dias);
}
</script>



<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.content {
  margin-bottom: 2rem;
}

h1 {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 32px;
  color: #001942;
}

.search {
  background: #fff;
  border-radius: 40px;
  display: flex;
  padding: 10px;
  align-items: center;
}

.search input {
  border: 2px solid #56008f;
  outline: none;
  width: 100%;
  padding: 10px;
  font-size: 12pt;
  font-family: "Poppins", sans-serif;
  background: #f4f7fe;
  color: #202020;
  border-radius: 0px 20px 20px 0px;
}

.search input::placeholder {
  color: #9d9d9d;
}

.ativo {
  background: #560382 !important;
  color: #b8d941 !important;
  font-weight: 700;
}

.search button {
  border: none;
  outline: none;
  background: #fef9ff;
  padding: 3px 10px;
  border-radius: 20px 20px 20px 20px;
  color: #000;
  margin-right: 10px;
}

.search .lupa {
  color: #9d9d9d;
  font-size: 15px;
}

.search i {
  color: #787878;
  font-size: 30px;
  margin: 0 10px;
}
</style>